/** @jsx jsx */
import { jsx } from '@emotion/core'
// import styled from '@emotion/styled'
import React, { useContext } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import { oaFuelCostMissingData } from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  isValidYearRange,
  // hasAccesPermits,
} from 'core'

import { DatePicker } from 'antd'

import {
  DatePickerContext,
  PNodeZoneContext,
  UnitSelectionContext,
} from 'context'

import CommonScreen from 'admin/component/CommonScreen'
// import MarginAnalysisUnitSelection from 'marginanalysis/MarginAnalysisUnitSelection'

const OaFuelCostsMissHeaders = [
  // strCol({ ident: 'utility', display: 'Utility', isFiltered: true }),
  // strCol({ ident: 'unit', display: 'Unit', isFiltered: true }),
  strCol({ ident: 'unitid', display: 'Unit', isFiltered: true, width: 450 }),
  dateCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isFiltered: true,
  }),
  strCol({
    ident: 'pfuelCode',
    display: 'Primary fuelCode',
    isFiltered: true,
    width: 200,
  }),
  // modifierCol,
  // modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const FuelCostMissingData = ({ targetInfo, units, ...props }) => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )

  // eslint-disable-next-line no-unused-vars
  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )

  const headerWithFormatter = OaFuelCostsMissHeaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,

          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const { selectedUnits } = useContext(UnitSelectionContext)

  // eslint-disable-next-line no-unused-vars
  const screenCriteria = (s, p, u, onCriteriaChnage, d) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onCriteriaChnage()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })
  const withCriteria = _ => {
    return {
      units: selectedUnits.map(u => u.unitId),
      startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
    }
  }
  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  return (
    <div>
      {/* <div style={{ marginLeft: '20px', marginRight: '20px' }}>
        <MarginAnalysisUnitSelection />
      </div> */}
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        beforeRetrieveValidation={beforeRetrieveValidation}
        withUnitSelection
        screenCriteria={screenCriteria}
        withCriteria={withCriteria}
        retrieveTask={oaFuelCostMissingData}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withoutModify
        withDelete={false}
        allowInsert={false}
        isEditableGrid={false}
        autoRetrieve={false}
        isAdminScreen={false}
        title="Fuel Cost Missing Data"
        header={headerWithFormatter}
        altBy={u => u.unitId}
        sortOptions={OaFuelCostsMissHeaders}
        initialSortOptions={OaFuelCostsMissHeaders}
        widthOffset={50}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(FuelCostMissingData)
